import React from "react";
import TimeRangeSelect from "react-time-range-select";
import { window } from "browser-monads";
import { FormControl, FormGroup, FormControlLabel, Checkbox } from "@material-ui/core";

export const TimeRangeSelector = ({
  title,
  state,
  changeStartTime,
  changeEndTime,
  day,
  open,
  handleOpen
}) => {
  return (
    <div className="timeRangeSelector__wrapper">
      <div>
        <FormControl className="timeRangeSelector__isOpen">
          <FormGroup></FormGroup>
          <FormControlLabel
            control={<Checkbox checked={open} onChange={e => handleOpen(e, day)} name="open" />}
            label={`${title}`}
          />
        </FormControl>
      </div>

      {!open && <div className="timeRangeSelector__placefiller"></div>}

      {window && open && (
        <TimeRangeSelect
          startTime={state.startTime}
          endTime={state.endTime}
          mode24Hours
          onChangeStart={e => changeStartTime(e, day)}
          onChangeEnd={e => changeEndTime(e, day)}
          startLabel={"von"}
          endLabel={"bis"}
          endTimeError={
            "Bitte geben Sie eine gültige Zeit ein. Die Endzeit kann nicht vor der Startzeit liegen."
          }
        />
      )}
    </div>
  );
};
